import React, { useEffect, useState } from 'react';
import client from '../../logic/courses';
import { IonSpinner } from '@ionic/react';
import Collapsible from 'react-collapsible';
import CollapsibleTrigger from '../UI/CollapsibleTrigger';
import Products from './Products';
import dl from '../../utils/device-language';
import { useFilters } from '../../utils/contexts/filters-context';
import forms from '../../utils/forms';
import { useTranslation } from 'react-i18next';
import { useTracker } from '../../utils/contexts/tracker-context';
import { useParams } from 'react-router';
import { useRestaurant } from '../../utils/contexts/restaurant-context';

function Row(props) {
    const { course, index } = props;

    const { filters } = useFilters();
    const { i18n } = useTranslation();
    const { trackDataFn } = useTracker();
    const { type } = useParams();
    const { restaurant } = useRestaurant();

    const [products, setProducts] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);

    async function onOpening() {
        // populate products with course products
        // products are loaded from courses logic
        await trackDataFn(restaurant.id, restaurant.token, "courseopen", {
            "type": type,
            "name": this.trigger.props.trigger.name,
            "id": course.id,
        }, restaurant.has_orders);

        let clientCourse;

        let language = process.env.REACT_APP_LANGUAGESELECTOR === "true" ? i18n.language : dl.getApiLanguage();
        const { allergies, foods, diets } = forms.parseFilters(filters);

        if (allergies || foods || diets) {
            clientCourse = await client.doGetFilters(language, course.id, allergies, foods, diets);
        } else {
            clientCourse = await client.doGet(language, course.id);
        }

        setProducts(clientCourse.dishes);
        setLoading(false);
    }

    useEffect(() => {
        if (open == true) {
            setOpen(prevState => !prevState);
        }
    }, [filters])

    return (
        <Collapsible
            className="row"
            tabIndex={index}
            trigger={<CollapsibleTrigger index={index} trigger={course} setOpen={setOpen}></CollapsibleTrigger>}
            triggerWhenOpen={<CollapsibleTrigger index={index} trigger={course} opened setOpen={setOpen}></CollapsibleTrigger>}
            onTriggerOpening={onOpening}
            open={open}>
            <div>
                {isLoading ?
                    <IonSpinner name="dots" /> :
                    <Products products={products} index={index} />
                }
            </div>
        </Collapsible>
    );
}

export default Row;
